import { useEffect } from "react";

export const SITE_URL = "https://safehomesecurity.ca";
export const DEFAULT_TITLE =
  "Security Camera & Technology Installation in New Brunswick | SafeHome Security Solutions";
export const DEFAULT_DESCRIPTION =
  "SafeHome Security Solutions provides security camera installation, access control, video doorbells, WiFi, structured cabling and more across New Brunswick.";

const upsertHead = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

// Keeps title, meta description, canonical and robots correct per route,
// so future /services/... and /service-areas/... pages are indexable with proper metadata.
export const usePageMeta = ({ title, description, path = "/", noindex = false } = {}) => {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    const desc = upsertHead('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.name = "description";
      return m;
    });
    desc.setAttribute("content", description || DEFAULT_DESCRIPTION);

    const canonical = upsertHead('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.rel = "canonical";
      return l;
    });
    canonical.setAttribute("href", SITE_URL + path);

    const robots = upsertHead('meta[name="robots"]', () => {
      const m = document.createElement("meta");
      m.name = "robots";
      return m;
    });
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
};
